import * as React from "react";

import H4 from "src/components/general/headings/H4";
import { ICouncil } from "src/interfaces";
import LibrarySignTrace from "./LibrarySignTrace";
import LibraryProgramAttendanceTrace from "./LibraryProgramAttendanceTrace";
import LibraryVisitsTrace from "./LibraryVisitsTrace";

// const councils = [
//   { name: "Brisbane Brisbane Birsbane", books: 8.4 },
//   { name: "Brisbane Brisbane Birsbane brisbane", books: 7.9 },
//   { name: "Brisbane Brisbane Birsbane", books: 5.3 },
//   { name: "Brisbane Brisbane Birsbane", books: 7.3 }
// ];

interface IProps {
  councils: ICouncil[];
  year: string;
  activeTab: number;
  dropdownOpen: boolean;
}

export default class LibrarySign extends React.PureComponent<
IProps, 
{ 
  activeTab: number, 
  dropdownOpen: boolean 
}
> {
  
  constructor(props: IProps){
      super(props);
      this.state = {
        activeTab: this.props.activeTab,
        dropdownOpen: this.props.dropdownOpen
      };
  }


  public handleChangeTab(n: number) {
      this.setState({ 
        activeTab: n,
        dropdownOpen: false
     });
  }

  public handleToggleDropdown( current: boolean ) {
      this.setState({ dropdownOpen: !current });
  }


  public render() {
    const councils = this.props.councils;
    return (
      <div>
        <div className="tab">
          <div className="relative">
            <button onClick={ () => this.handleToggleDropdown( this.state.dropdownOpen ) } className={ ( this.state.dropdownOpen ) ? 'tab__dropdown tab__dropdown--active font-bold text-xs tab-btn lg:hidden' : 'tab__dropdown font-bold text-xs tab-btn lg:hidden' }>Choose Data Type</button>
            <ul className="lg:my-8 tab__options" id="tab-options-library">
                <li>
                  <H4>
                  <a onClick={ () => this.handleChangeTab( 1 ) } 
                    className={ ( this.state.activeTab === 1 ) ? 'tab-btn tab-btn--active' : 'tab-btn' }>Visits per resident</a>
                  </H4>
                </li>
                <li>
                  <H4>
                  <a onClick={ () => this.handleChangeTab( 2 ) } 
                    className={ ( this.state.activeTab === 2 ) ? 'tab-btn tab-btn--active' : 'tab-btn' }>Loans per resident</a>
                  </H4>
                </li>
                <li>
                  <H4>
                  <a onClick={ () => this.handleChangeTab( 3 ) } 
                    className={ ( this.state.activeTab === 3 ) ? 'tab-btn tab-btn--active' : 'tab-btn' }>Program attendance</a>
                  </H4>
                </li>
            </ul>
          </div>
          {( this.state.activeTab === 1 ) && (
            <div className="mt-5 lg:mt-0 tab__content tab__content--active">
              <div className="flex flex-col">
                <div className="lg:hidden w-full mb-5"><H4>Visits per resident</H4></div>
                <div className="flex flex-row flex-wrap">
                  {councils.map((council, index) => (
                    <LibraryVisitsTrace
                      key={index}
                      council={council}
                      ordinal={index + 1}
                      year={this.props.year}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
          {( this.state.activeTab === 2 ) && (
            <div className="mt-5 lg:mt-0 tab__content tab__content--active">
              <div className="flex flex-col">
                <div className="lg:hidden w-full mb-5"><H4>Loans per resident</H4></div>
                <div className="flex flex-row flex-wrap">
                  {councils.map((council, index) => (
                    <LibrarySignTrace
                      key={index}
                      council={council}
                      ordinal={index + 1}
                      year={this.props.year}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
          {( this.state.activeTab === 3 ) && (
            <div className="mt-5 lg:mt-0 tab__content tab__content--active">
              <div className="flex flex-col">
                <div className="lg:hidden w-full mb-5"><H4>Program attendance</H4></div>
                <div className="flex flex-row flex-wrap">
                  {councils.map((council, index) => (
                    <LibraryProgramAttendanceTrace
                      key={index}
                      council={council}
                      ordinal={index + 1}
                      year={this.props.year}
                    />
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilExpenditure/Libraries/LibrarySign.tsx